import { EngagementBuyer } from '../../../slices/marketplace/timeline/models/engagement-buyer.model';
import { MarketplaceOpportunityStatus } from '../../../slices/marketplace/opportunity/models/opportunity-status';
import { isSelectableBuyer } from '../../../utils/isSelectableBuyer';

/**
 * True when every available (active) buyer is already selected for the given selection
 * action — there is nothing left to decide, so "Finalize selection" skips its confirmation
 * popup. A selected buyer reads Engaged (DFM, or a signed ID NDA) or Awaiting Buyer Response
 * (an ID NDA posted but not yet signed — #1733); both mean the seller is done. Zero active
 * buyers is not "all selected". Mirrors Timeline.IsBuyerSelectionComplete — keep the two in sync.
 */
export const areAllAvailableBuyersSelected = (
    buyers: EngagementBuyer[] | undefined,
    actionId: number | undefined
): boolean => {
    if (actionId == null) {
        return false;
    }
    const activeBuyers = buyers?.filter(isSelectableBuyer) ?? [];
    return (
        activeBuyers.length > 0 &&
        activeBuyers.every((buyer) =>
            buyer.actionState?.some(
                (state) =>
                    state.actionId === actionId &&
                    (state.buyerStatus ===
                        MarketplaceOpportunityStatus.Engaged ||
                        state.buyerStatus ===
                            MarketplaceOpportunityStatus.AwaitingBuyerResponse)
            )
        )
    );
};
